import { render, staticRenderFns } from "./DocumentRemoveModal.vue?vue&type=template&id=68b6e61c&"
import script from "./DocumentRemoveModal.vue?vue&type=script&lang=js&"
export * from "./DocumentRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports